<div ngModalContent class="u-text-center">
  <h2 nxHeadline="subsection-large" class="change-premium-modal_header">
    {{ 'modals.change-premium.title' | translate }}
  </h2>
  <ng-container [ngSwitch]="premiumStatus$ | async">
    <app-loader *ngSwitchCase="apiState.pending"></app-loader>
    <app-error *ngSwitchCase="apiState.error"></app-error>
    <ng-container *ngSwitchDefault>
      <form [formGroup]="form" class="change-premium-modal_form">
        <app-dynamic-input
          [formGroup]="form"
          name="percentIncrease"
          inputType="number"
          label="modals.change-premium.form.premium.label"
          suffix="modals.change-premium.form.premium.suffix"
        ></app-dynamic-input>
        <button nxButton type="submit" (click)="handleSubmit()" [disabled]="form.invalid">
          {{ 'modals.change-premium.form.button' | translate }}
        </button>
      </form>
    </ng-container>
  </ng-container>
</div>
